import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from 'react';
import { Loader } from '../../Elements/Loader';
import { Section } from '../Section';
import { InfoBlock, InfoDate, InfoLabel, InfoName } from './styled';
export const InformationCard = memo(function InformationCard({ items, isLoading }) {
    return (_jsx(Section, { children: isLoading ? (_jsx(InfoBlock, { children: _jsx(Loader, { size: '18px', content: true }) })) : (_jsx(_Fragment, { children: items.map((item) => (_jsxs(InfoBlock, { "data-testid": item.dataTestId, children: [_jsx(InfoLabel, { children: item.label }), item.title && _jsx(InfoName, { children: item.title }), item.date && _jsx(InfoDate, { children: item.date })] }, item.label))) })) }));
});
